module.exports = __webpack_public_path__ + "img/d.c321e120.jpg";